import eshopAction from '../actions/eshopActions';
let initialState = [];
function cards(state = initialState, eshopAction) {
    switch (eshopAction.type) {
        case 'ADD':
            var newState = [...state];
            newState.push(eshopAction.data);
            return newState;

        case 'REMOVE':
            var removeState = [...state];
            for (var i = 0; i < removeState.length; i++) {
                if(removeState[i].storeId === eshopAction.storeId) {
                    removeState.splice(i, 1);
                    break;
                }
            }
            return removeState;

        case 'UPDATE':
            var updateState = [...state];
            for (var z = 0; z < updateState.length; z++) {
                if(updateState[z].storeId === eshopAction.data.storeId) {
                    updateState[z] = eshopAction.data;
                    break;
                }
            }
            return updateState;

        case 'REMOVE_ALL':
            return []

        default:
            return state
    }
}

export default cards;



/** WEBPACK FOOTER **
 ** ./src/reducers/Cards.js
 **/